import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { initSentry } from './sentry';

initSentry(process.env.NODE_ENV);

ReactDOM.render(<App />, document.getElementById('root'));
